import type { CSSProperties } from 'react';

export const tagChipStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  minHeight: 24,
  padding: '2px 8px',
  borderRadius: 6,
  background: '#342431',
  border: '1px solid #7D3C69',
  color: '#F8B9E3',
  fontSize: 12,
  fontWeight: 500,
  lineHeight: '18px',
};

export const priorityChipStyles: Record<string, CSSProperties> = {
  LOW: {
    background: '#173C27',
    border: '1px solid #2E7650',
    color: '#B8F2CE',
  },
  MEDIUM: {
    background: '#443610',
    border: '1px solid #856A1C',
    color: '#FFE49A',
  },
  HIGH: {
    background: '#482A16',
    border: '1px solid #915128',
    color: '#FFC49B',
  },
  URGENT: {
    background: '#4A2028',
    border: '1px solid #963E50',
    color: '#FFB6C3',
  },
};

export const priorityChipBaseStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  minHeight: 24,
  padding: '2px 8px',
  borderRadius: 6,
  fontSize: 11,
  fontWeight: 700,
  lineHeight: '18px',
  letterSpacing: '0.02em',
  textTransform: 'uppercase',
};
